<template>
  <div id="search_modal" class="modal fade" role="dialog" aria-labelledby="myModalLabel10" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">SEARCH RESULTS</h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" role="form" v-on:submit.prevent="onSubmit">
            <div class="form-body">
              <div class="form-group form-md-line-input has-warning">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-control input-icon">
                      <i class="fa fa-search"></i>
                      <input type="text" class="form-control" placeholder="Type to search..." v-model="searchQuery">
                      <div class="form-control-focus"></div>
                    </div>
                    <span class="input-group-btn btn-right">
                     <button class="btn green mt-ladda-btn ladda-button search-btn-submit" ref="searchBtn" type="submit" data-style="expand-left">
                        <span class="ladda-label">Search</span>
                     </button>
                    </span>
                  </div>
                </div>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                  enabled: true,
                  perPageDropdown: [10, 20, 50, 100, 200, 500],
                  dropdownAllowAll: true,
                  perPage: this.serverParams.perPage
                }"
                mode="remote"
                v-if="haveResults"
                :totalRows="totalRecords"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'participant_name'">
                        <router-link :to="{ name: 'Dashboard Participant', params: { id: props.row.id } }" tag="a" class="" data-dismiss="modal" aria-hidden="true">{{ props.row.participant_name }}</router-link>
                  </span>
                  <span v-else-if="props.column.field == 'date_completed.date'">{{ props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else-if="props.column.field == 'date_of_birth.date'">{{ props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
              </vue-good-table>
              <div class="not-found-results" v-else="">
                <h4>Sorry, no search results were found.</h4>
                <h5>Search Suggestions:</h5>
                <ul>
                  <li>Check your spelling</li>
                  <li>Search by {{ participantSingularName }} Name, System ID or Organization ID</li>
                </ul>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {HTTP, ERROR} from '@/http-common';
  import {mapGetters} from 'vuex';
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    props: ['query', 'refreshSearch'],
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        modalTitle: 'Search modal',
        searchQuery: this.query,
        haveResults: false,
        participants: [],
        columns: [],
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10
        },
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      })
    },
    methods: {

      onSubmit() {
        if (this.searchQuery.length < 1) {
          this.haveResults = 0;
          this.$notify({
            type: 'error',
            text: 'Please fill search field.'
          });
          return false;
        }
        this.onSearch();
      },

      onSearch() {
        this.button = Ladda.create(document.querySelector('.search-btn-submit'));
        this.button.start();

        HTTP.post(`search`, {
          keyword: this.searchQuery,
          limit: this.serverParams.perPage,
          current_page: this.serverParams.page,
          sort_by: this.serverParams.sort.field,
          sort_order: this.serverParams.sort.type,
        }).then(response => {
            ERROR(response);
            if (response.status === 200) {
              this.rows = response.data.data.rows;
              this.columns =
                _.map(response.data.data.columns, (column) => {
                  if (column.field.includes('date_')) {
                    column.thClass = 'vgt-left-align';
                    column.tdClass = 'vgt-left-align';
                    column.sortFn = this.dateSortFn;
                  }
                  return column;
                });

              this.totalRecords = response.data.data.results_num;
              (this.rows.length > 0) ? this.haveResults = true : this.haveResults = false;
            }
            this.button.stop();
          }).catch(err => {
          console.log(err);
        });
      },

      dateSortFn(x, y, col, rowX, rowY) {
        let xDate = moment(x).unix();
        let yDate = moment(y).unix();
        return (xDate < yDate ? -1 : (xDate > yDate ? 1 : 0));
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.onSearch();
      },

      onPageChange(params) {
        this.updateParams({page: params.currentPage});
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage, page: 1});

      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field
          },
        });
      },

      onColumnFilter(params) {
        this.updateParams(params);
      },
    },

    watch: {
      query: function () {
        const btn = this.$refs.searchBtn;
        this.searchQuery = this.query;
        btn.click();
      },
      refreshSearch: function () {
        const btn = this.$refs.searchBtn;
        this.searchQuery = this.query;
        btn.click();
      }
    },

  }
</script>
<style>
  .table-footer {
    background-color: transparent !important;
  }

  .table thead th, .table.condensed thead th {
    background-color: transparent !important;
  }

  .table input {
    width: 100% !important;
    font-size: 10px !important;
    padding: 6px 0px !important;
    border: none !important;
  }

  .not-found-results {
    padding-top: 10px;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// SearchModal.vue?60ed83f8